import { Injectable } from "@angular/core";
import { take, tap } from "rxjs/operators";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { ModalService } from "@core-services/modal.service";
import { Router } from "@angular/router";
import { FiatDepositNavigationService } from "@modules/+new/payments/features/fiat-deposit/domain/+state/fiat-deposit-navigation.service";
import { FiatDepositStepNames } from "@modules/+new/payments/features/fiat-deposit/domain/entities/fiat-deposit-step-names.enum";

@Injectable({
	providedIn: "root"
})
export class FiatDepositEntryService {
	private isNewDepositFlowEnabled: boolean = false;

	public constructor(
		private readonly launchDarklyService: LaunchDarklyService,
		private readonly modalService: ModalService,
		private readonly router: Router,
		private navService: FiatDepositNavigationService
	) {}

	public initNewDepositFlowStatus(): void {
		this.launchDarklyService
			.isActive$(LD_FLAG.DEPOSIT_NEW_DEPOSIT_FLOW_ENABLED)
			.pipe(tap((isActive: boolean) => (this.isNewDepositFlowEnabled = isActive)))
			.subscribe();
	}

	public openDeposit(): void {
		this.newDepositFlow();
	}

	public openDepositForWallet(walletId: string, fiatPid: string): void {
		this.navService
			.navigateToStep$(FiatDepositStepNames.SelectPaymentOption, { walletGuid: walletId, fiatPid: fiatPid })
			.pipe(take(1))
			.subscribe();
	}

	public openDepositNow(): void {
		this.router.navigate([{ outlets: { modal: ["payments", "deposit-now"] } }], { skipLocationChange: true });
	}

	private newDepositFlow(): void {
		this.router.navigate([{ outlets: { modal: ["fiat-deposit"] } }], { queryParamsHandling: "merge" });
	}
}
